import React from 'react'
import { h } from '@app/helpers/translationHelper'
import SVG from "react-inlinesvg";

import pen from '@icons/pen.svg';

const Motivation = (props) => {
  return (
    <div className="section goals-section">
      <h1 className="plate-heading plate-heading--left">
        { I18n.t('landing.why') }
      </h1>
      <div className="grid grid--md-2--kv grid--xl-2--kv">
        <div className="w-flex-layout w-flex-layout--columns w-flex-layout--jc-start">
          <div className="f--md f--default"
             dangerouslySetInnerHTML={h('landing.why_text_2_html')}
          />
          <div className="f--md f--default"
             dangerouslySetInnerHTML={h('landing.why_text_3_html')}
          />
          <SVG src={pen} className="goals-section__pen" />
        </div>
      </div>
    </div>
  )
}

export default Motivation
